import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchSections(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/sections', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchSection(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/sections/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addSection(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/sections`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteSection(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/sections/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateSection(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/sections/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}